// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.operationClass{padding:10px 0!important;min-width:0}.el-popover.operationClass .moreOperation{color:#333;font-size:12px}.el-popover.operationClass .moreOperation div{padding:5px 10px;cursor:pointer}.el-popover.operationClass .moreOperation div:hover{background:#006dcc;color:#fff}", ""]);
// Exports
module.exports = exports;
